module.exports = __webpack_public_path__ + "assets/img/comp_6.e70c05e6.png";